import { Component, Input, OnDestroy, OnInit, Output, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import { firstValueFrom, Observable, of, Subject } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { getCellRenderer, getValueGetter, getCellFilter, getCellSort } from 'src/app/modules/core/components/ag-grid';
import { UserApiService } from 'src/app/modules/management/store/users';
import * as fromSecurityGroup from 'src/app/modules/management/store/security-groups';
import { CommunicationsApiService } from 'src/app/modules/communications/store/communications/communications-api.service';
import {
  MassRecipientType,
  DatasetSelectedRecipientFilter,
  DistributionList,
  DocumentSelectionInfo,
  DistributionListType
} from 'src/app/modules/communications/store/communications/communications.model';
import { DataTableServerComponent } from 'src/app/modules/core/components/data-table-server/data-table.component';
import { ApplyColumnStateParams, GetRowIdParams, IServerSideDatasource, ValueFormatterParams } from 'ag-grid-enterprise';
import { GridHelperService } from 'src/app/modules/core/services/grid-helper.service';
import { FieldDataType, SchemaField, SystemFieldType } from 'src/app/modules/management/store/data/data.model';
import { v4 as uuidv4 } from 'uuid';
import { PicklistService } from 'src/app/modules/core/services/picklist/picklist.service';
import { DatasetApiService } from 'src/app/modules/core/services/dataset-api.service';
import { Dataset, DatasetSubtype, DatasetType } from 'src/app/modules/core/store/models/dataset.model';
import {
  DocumentQueryParams,
  DocumentReader,
  FilterGroup,
  FilterGroupType,
  QueryParams,
  QueryParamsForSelection,
  RuleOperator,
  TableFilter,
  View,
  ViewControlType,
  Workflow
} from 'src/app/modules/core/store/models';
import { DataApiService } from 'src/app/modules/management/store/data/data-api.service';
import { UserContextService } from 'src/app/modules/core/services/user-context.service';
import { UserContext, Permissions } from '@app/modules/authentication/store/auth';
import { cloneDeep } from 'lodash-es';
import { RecipientSelectionService } from 'src/app/modules/communications/services/recipient-selection-service';
import { TableColumnsService } from 'src/app/modules/cop/services/table/table-columns-service';
import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { ConfirmationDialogComponent } from '@app/shared/components/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'topo-comms-recipient-list-select',
  templateUrl: './recipient-list-select.component.html',
  styleUrls: ['./recipient-list-select.component.scss'],
  standalone: false
})
export class RecipientListSelectComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() includeAssetDatasets: boolean;
  _isActive: boolean;

  @Input() set isActive(value: boolean) {
    this._isActive = value;
    if (this._isActive == true) {
      setTimeout(() => {
        this.dataTable?.groupRows(false);
        this.dataTable?.resetFilter();
      }, 200);
    }

    if (this._isActive === true) {
      if (!!!this.intitalSelectedTypeUId) {
        this.selectedRecipentTypeUId = this.recipientTypes[0].uId;
        this.previousSelectedRecipentTypeUId = this.selectedRecipentTypeUId;
      } else {
        this.selectedRecipentTypeUId = this.intitalSelectedTypeUId;
        this.previousSelectedRecipentTypeUId = this.selectedRecipentTypeUId;
      }

      this.loadData();
    }
  }

  @Input() getSelectedUIds: (type: MassRecipientType, parentUId: string) => any = null;
  @Input() isDuplicateFilter: (uId: string, datasetUId: string, filter: TableFilter) => any = null;

  @Input() intitalSelectedTypeUId: string;

  @Input() set recipientFilters(filters: DatasetSelectedRecipientFilter[]) {
    this.selectedRecipientFilters = cloneDeep(filters);
  }
  get isActive(): boolean {
    return this._isActive;
  }

  @Output() recipientsSelected = new EventEmitter<SelectedRecipientInfo>();
  @Output() recipientsClosed = new EventEmitter();

  @Input() includeUsers: boolean;
  @Input() includeGroups: boolean;
  @Input() includeDistro: boolean;
  @Input() includeDatasets: boolean;
  @Input() includeClosestAssets: boolean;

  @Input() readonlyTemplateRecipients: boolean;

  @ViewChild('table') dataTable: DataTableServerComponent;

  headerLabel: string;
  headerIcon: string;
  datasource: any;
  columDefs: any[] = [];
  skip = 0;
  take = 10;
  totalCount: number = 0;
  selectedRecipentType: any;
  selectedRecipentTypeUId: string;
  previousSelectedRecipentTypeUId: string;
  recipientTypes: any[];
  searchFilterGroup: FilterGroup;
  selectedOnlyMode: boolean = true;
  selectedRecipientFilters: DatasetSelectedRecipientFilter[];
  canChangeType: boolean;
  isDirty: boolean;
  allowSaveAll: boolean;
  isLoading: boolean;
  isDatasetSelected: boolean;
  hasDistTypes: boolean;
  defaultTableView: View;
  detailsContext: any;
  selectedUIds: string[];
  selectionFilter: string;
  membersCount: any[];
  Permissions: Permissions;

  destroy$: Subject<void> = new Subject<void>();

  public userRecipientTypeUId: string = '78a0e907-ccc0-45c7-8030-57f645323230';
  public groupRecipientTypeUId: string = '3d114d92-ab9d-46c7-b5d6-7bdc9ce2ef97';
  public distRecipientTypeUId: string = '44fbd229-6f7a-49f0-bc0d-b62398e19182';
  public assetsRecipientTypeUId: string = '5e95e4e5-12b9-46e3-bc7c-2dea206bdb09';

  selectedDistributionListType: DistributionListType = DistributionListType.None;
  distributionListTypes = [
    {
      value: DistributionListType.None,
      name: this.translateService.instant(`COMMUNICATIONS.DISTRIBUTION-LIST-TYPE-${DistributionListType.None}`)
    },
    {
      value: DistributionListType.FusionTeam,
      name: this.translateService.instant(`COMMUNICATIONS.DISTRIBUTION-LIST-TYPE-${DistributionListType.FusionTeam}`)
    }
  ];

  tableWidth = '70vw';
  tableHeight = '60vh';

  constructor(
    private translateService: TranslateService,
    private gridHelper: GridHelperService,
    private picklistService: PicklistService,
    private datasetApiService: DatasetApiService,
    private dataApiService: DataApiService,
    private userApiService: UserApiService,
    private communicationsApiService: CommunicationsApiService,
    private securityGroupApi: fromSecurityGroup.SecurityGroupApiService,
    private userContextService: UserContextService,
    private tableColumnsService: TableColumnsService,
    private recipientSelectionService: RecipientSelectionService,
    private dialog: Dialog
  ) {}

  ngOnInit(): void {
    this.loadRecipientTypes();

    this.datasource = this.getServerSideDatasource();
  }

  ngAfterViewInit() {
    this.dataTable?.groupRows(false);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getRowId = (params: GetRowIdParams): string => {
    const type = this.getMassRecipientType();
    return type === MassRecipientType.Document ? params.data.uid : params.data.uId;
  };

  getServerSideDatasource(): IServerSideDatasource {
    return {
      getRows: params => {
        let translatedParams = this.gridHelper.gridParamsToRequestParams(params.request);
        if (this.selectedRecipentTypeUId === this.userRecipientTypeUId) {
          if (params.request.sortModel.length > 0) {
            if (params.request.sortModel[0].colId == 'uId') {
              params.request.sortModel[0].colId = 'displayName';
              translatedParams = this.gridHelper.gridParamsToRequestParams(params.request);
            }
          }
          const queryParams: QueryParamsForSelection = {
            ...translatedParams
          };

          if (!!this.selectedUIds) {
            queryParams.selected = this.selectedUIds;
            if (this.readonlyTemplateRecipients === true) {
              queryParams.selectedOnly = true;
            }
          }

          if (!!!queryParams.sortField) {
            queryParams.sortField = '_selected';
            queryParams.sortDirection = 'Descending';
            queryParams.thenSortField = 'display_name';
            queryParams.thenSortDirection = 'Ascending';
          }

          return this.userApiService.getUsersForSelection(this.userContextService.getUserContext().organizationUId, queryParams).subscribe(
            resp => {
              const response = this.gridHelper.queryResultToGridData(resp);
              this.totalCount = response?.rowCount;

              params.success({
                rowData: response?.rowData,
                rowCount: response?.rowCount
              });
            },
            err => params.fail()
          );
        } else if (this.selectedRecipentTypeUId === this.groupRecipientTypeUId) {
          this.securityGroupApi.getSecurityGroups(this.userContextService.getUserContext().organizationUId, translatedParams).subscribe(
            resp => {
              const response = this.gridHelper.queryResultToGridData(resp);
              this.totalCount = response?.rowCount;

              params.success({
                rowData: response?.rowData,
                rowCount: response?.rowCount
              });
            },
            err => params.fail()
          );
        } else if (this.selectedRecipentTypeUId === this.distRecipientTypeUId) {
          const queryParams: QueryParamsForSelection = {
            ...translatedParams
          };

          if (!!this.selectedUIds) {
            queryParams.selected = this.selectedUIds;
            if (this.readonlyTemplateRecipients === true) {
              queryParams.selectedOnly = true;
            }
          }

          if (!!!queryParams.sortField) {
            queryParams.sortField = '_selected';
            queryParams.sortDirection = 'Descending';
            queryParams.thenSortField = 'name';
            queryParams.thenSortDirection = 'Ascending';
          }

          const listTypeWhere = `DistributionListType = DistributionListType.${DistributionListType[this.selectedDistributionListType]}`;

          if (!!queryParams.where) {
            queryParams.where = `(${queryParams.where}) AND ${listTypeWhere}`;
          } else {
            queryParams.where = listTypeWhere;
          }

          return this.communicationsApiService.getDistributionListsForSelection(queryParams).subscribe(
            resp => {
              const response = this.gridHelper.queryResultToGridData(resp);
              this.totalCount = response?.rowCount;
              const rowData = response?.rowData?.map(d => {
                const data = {
                  ...d,
                  membersCount: null
                };
                return data;
              });

              params.success({
                rowData: rowData,
                rowCount: response?.rowCount
              });

              this.getMembersCount(rowData);
            },
            err => params.fail()
          );
        } else {
          const filterGroup: FilterGroup = {
            filterGroups: [],
            filters: [],
            groupType: FilterGroupType.And
          };

          const tablefilterGroup = this.getFilterGroupFromTableFilter();
          if (!!tablefilterGroup) {
            filterGroup.filterGroups.push(tablefilterGroup);
          }

          const columnFilterGroup = this.tableColumnsService.getColumnFilterFromGrid(params?.request.filterModel);
          if (!!columnFilterGroup) {
            filterGroup.filterGroups.push(columnFilterGroup);
          }

          if (!!this.searchFilterGroup) {
            filterGroup.filterGroups.push(this.searchFilterGroup);
          }

          var documentQuery = {
            pagination: {
              skip: translatedParams.skip,
              take: translatedParams.take
            },
            sort: translatedParams.sort,
            filterGroup: filterGroup
          } as DocumentQueryParams;

          if (!!!documentQuery.sort) {
            documentQuery.sort = '_selected desc';
            const firstColumn = !!this.columDefs && this.columDefs.length > 1 ? this.columDefs[1].colId : null;
            if (!!firstColumn) {
              documentQuery.sort += `,${firstColumn} asc`;
            }
          }

          if (!!this.selectedUIds) {
            documentQuery.selected = this.selectedUIds;
            if (this.readonlyTemplateRecipients === true) {
              filterGroup.filterGroups.push(this.getFilterGroupFromSelection(this.selectedUIds));
            }
          }

          this.dataApiService.getDocuments(this.selectedRecipentTypeUId, documentQuery).subscribe(
            resp => {
              const response = this.gridHelper.queryResultToGridData(resp);
              this.totalCount = response?.rowCount;

              params.success({
                rowData: response?.rowData,
                rowCount: response?.rowCount
              });
            },
            err => params.fail()
          );
        }
      }
    };
  }

  onPaginate(skip: number): void {
    this.skip = skip;
  }

  onTakeChanged(take: number): void {
    this.take = take;
  }

  private generateColumns(): any[] {
    if (this.selectedRecipentTypeUId === this.userRecipientTypeUId) {
      return this.generateUserColumns();
    } else if (this.selectedRecipentTypeUId === this.groupRecipientTypeUId) {
      return this.generateGroupColumns();
    } else if (this.selectedRecipentTypeUId === this.distRecipientTypeUId) {
      return this.generateDistColumns();
    } else {
      return this.generateDatasetColumns();
    }
  }

  private generateDatasetColumns(): any[] {
    return this.getDatasetColumns(this.selectedRecipentType, this.userContextService.getUserContext()?.organizationUId);
  }

  private getMembersCount(dists: any[]): void {
    const uids = dists.map(n => n.uId);

    this.communicationsApiService.getDistributionListMembersCount(uids).subscribe(resp => {
      this.membersCount = [];
      resp.forEach(r => {
        const dist = dists.find(n => n.uId === r.distributionListUId);
        if (!!dist) {
          this.membersCount.push({
            uId: dist.uId,
            count: r.count
          });
          dist.membersCount = r.count;
          const rowNode = this.dataTable?.gridApi?.getRowNode(dist.uId);
          if (!!rowNode) {
            rowNode.setDataValue('membersCount', r.count);
          }
        }
      });
    });
  }

  getDatasetColumns(dataset: Dataset, organizationUId: string) {
    const fieldNames = [];

    if (!!!dataset) {
      return [];
    }

    const tableView = dataset?.workflow.views.find(vw => vw.name === 'table');

    tableView.controls.map(c => {
      const field = dataset.schema.fields.find(f => f.uId === c.dataSetFieldUId);
      if (!!field) {
        fieldNames.push(`${field.systemName}`);
      }
    });

    return this.generateTableColumns(fieldNames, dataset, dataset.workflow, organizationUId);
  }

  private generateTableColumns(fieldNames: string[], dataset: Dataset, workflow: Workflow, organizationUId: string) {
    const columns = [];

    if (this.readonlyTemplateRecipients !== true) {
      columns.push({
        colId: '_selected',
        headerClass: 'ag-header-no-label',
        sortable: true,
        checkboxSelection: true,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        resizable: false,
        pinned: 'left',
        menuTabs: [],
        width: 40,
        maxWidth: 60,
        minWidth: 60
      });
    }

    fieldNames.map(c => {
      const fieldName = c;
      const field = dataset.schema.fields.find(f => f.systemName === fieldName);
      if (!!field) {
        let cellRenderer: string;
        cellRenderer = getCellRenderer(field.dataType);

        const valueGetter = getValueGetter(field.dataType);

        const filter = getCellFilter(field.dataType);

        const sortColId = getCellSort(field);

        columns.push({
          headerName: field.displayName,
          field: field.systemName,
          colId: `${field.systemName}`,
          enableRowGroup: true,
          filterParams: {
            buttons: ['reset', 'apply'],
            debounceMs: 1000,
            valueFormatter: filter === 'agSetColumnFilter' ? this.formatTextForTable : null,
            suppressAndOrCondition: true,
            filterOptions:
              filter === 'agSetColumnFilter'
                ? field.dataType === FieldDataType.Text || field.dataType === FieldDataType.Email
                  ? ['equals', 'notEqual', 'equalsNoCase', 'notEqualNoCase', 'contains', 'notContains', 'blank', 'notBlank']
                  : ['equals', 'notEqual', 'contains', 'notContains', 'blank', 'notBlank']
                : undefined
          },

          filter: filter === 'agSetColumnFilter' ? 'agTextColumnFilter' : filter,
          floatingFilter: false,
          sortable: true,
          resizable: true,
          minWidth: 150,
          menuTabs: ['filterMenuTab'],
          cellRenderer,
          cellRendererParams: {
            schemaField: field,
            organizationUId: organizationUId,
            sortFieldName: sortColId !== field.systemName ? sortColId : undefined,
            workflows: [workflow]
          },
          valueGetter
        });
      }
    });

    return columns;
  }

  formatTextForTable(params: ValueFormatterParams) {
    const text = params.value;
    if (text) {
      return text.replace(/(\r\n|\n|\r)/gm, '');
    }
    return text;
  }

  private generateDistColumns(): any[] {
    var columns = [];

    if (this.readonlyTemplateRecipients !== true) {
      columns.push({
        colId: '_selected',
        headerClass: 'ag-header-no-label',
        sortable: true,
        checkboxSelection: true,
        // headerCheckboxSelection: true,
        // headerCheckboxSelectionFilteredOnly: true,
        resizable: false,
        pinned: 'left',
        menuTabs: [],
        width: 40,
        maxWidth: 60,
        minWidth: 60
      });
    }

    const nameField = {
      dataType: FieldDataType.Text,
      displayName: this.translateService.instant('COMMUNICATIONS.COLUMNS.NAME'),
      systemName: 'name',
      uId: uuidv4(),
      isUniqueKey: false,
      fieldType: SystemFieldType.System,
      picklistValues: [],
      sourceUnit: null,
      settings: null
    } as SchemaField;

    var valueGetter = getValueGetter(FieldDataType.Text);
    var cellRenderer = 'linkCellComponent';
    columns.push({
      headerName: nameField.displayName,
      field: nameField.systemName,
      colId: 'name',
      sortable: true,
      resizable: true,
      minWidth: 300,
      maxWidth: 350,
      menuTabs: [],
      cellRenderer,
      cellRendererParams: {
        schemaField: nameField,
        picklistService: this.picklistService,
        clicked: data => {
          this.openDistributionListDetails(data);
        }
      },
      valueGetter
    });

    const desc = {
      dataType: FieldDataType.Text,
      displayName: this.translateService.instant('COMMUNICATIONS.COLUMNS.DESCRIPTION'),
      systemName: 'description',
      uId: uuidv4(),
      isUniqueKey: false,
      fieldType: SystemFieldType.System,
      picklistValues: [],
      sourceUnit: null
    } as SchemaField;

    valueGetter = getValueGetter(FieldDataType.Text);
    cellRenderer = getCellRenderer(FieldDataType.Text);
    columns.push({
      headerName: desc.displayName,
      field: desc.systemName,
      colId: 'description',
      sortable: true,
      resizable: true,
      minWidth: 200,
      menuTabs: [],
      cellRenderer,
      cellRendererParams: {
        schemaField: desc,
        picklistService: this.picklistService
      },
      valueGetter
    });

    const members = {
      dataType: FieldDataType.Number,
      displayName: this.translateService.instant('COMMUNICATIONS.COLUMNS.NUMBER-OF-MEMBERS'),
      systemName: 'membersCount',
      uId: uuidv4(),
      isUniqueKey: false,
      fieldType: SystemFieldType.System,
      picklistValues: [],
      sourceUnit: null,
      settings: {
        format: 'NUMBER'
      }
    } as SchemaField;

    valueGetter = getValueGetter(FieldDataType.Number);
    cellRenderer = getCellRenderer(FieldDataType.Number);
    columns.push({
      headerName: members.displayName,
      field: members.systemName,
      colId: 'membersCount',
      sortable: false,
      resizable: true,
      width: 200,
      menuTabs: [],
      cellRenderer,
      cellRendererParams: {
        schemaField: members,
        picklistService: this.picklistService
      },
      valueGetter
    });

    return columns;
  }

  private generateGroupColumns(): any[] {
    var columns = [];

    if (this.readonlyTemplateRecipients !== true) {
      columns.push({
        colId: '_selectionChecks',
        checkboxSelection: true,
        // headerCheckboxSelection: true,
        // headerCheckboxSelectionFilteredOnly: true,
        resizable: false,
        pinned: 'left',
        width: 40,
        maxWidth: 40,
        minWidth: 60
      });
    }

    const nameField = {
      dataType: FieldDataType.Text,
      displayName: this.translateService.instant('COMMUNICATIONS.COLUMNS.NAME'),
      systemName: 'displayName',
      uId: uuidv4(),
      isUniqueKey: false,
      fieldType: SystemFieldType.System,
      picklistValues: [],
      sourceUnit: null,
      settings: null
    } as SchemaField;

    var valueGetter = getValueGetter(FieldDataType.Text);
    var cellRenderer = getCellRenderer(FieldDataType.Text);
    columns.push({
      headerName: nameField.displayName,
      field: nameField.systemName,
      colId: 'displayName',
      sortable: true,
      resizable: true,
      minWidth: 300,
      menuTabs: [],
      cellRenderer,
      cellRendererParams: {
        schemaField: nameField,
        picklistService: this.picklistService,
        clicked: data => {}
      },
      valueGetter
    });

    const members = {
      dataType: FieldDataType.Text,
      displayName: this.translateService.instant('COMMUNICATIONS.COLUMNS.NUMBER-MEMBERS'),
      systemName: 'memberCount',
      uId: uuidv4(),
      isUniqueKey: false,
      fieldType: SystemFieldType.System,
      picklistValues: [],
      sourceUnit: null
    } as SchemaField;

    valueGetter = getValueGetter(FieldDataType.Text);
    cellRenderer = getCellRenderer(FieldDataType.Text);
    columns.push({
      headerName: members.displayName,
      field: members.systemName,
      colId: 'memberCount',
      sortable: true,
      resizable: true,
      minWidth: 300,
      menuTabs: [],
      cellRenderer,
      cellRendererParams: {
        schemaField: members,
        picklistService: this.picklistService
      },
      valueGetter
    });

    return columns;
  }

  private generateUserColumns(): any[] {
    var columns = [];

    if (this.readonlyTemplateRecipients !== true) {
      columns.push({
        colId: '_selected',
        headerClass: 'ag-header-no-label',
        sortable: true,
        checkboxSelection: true,
        // headerCheckboxSelection: true,
        // headerCheckboxSelectionFilteredOnly: true,
        resizable: false,
        pinned: 'left',
        menuTabs: [],
        width: 40,
        maxWidth: 60,
        minWidth: 60
      });
    }
    const nameField = {
      dataType: FieldDataType.User,
      displayName: this.translateService.instant('COMMUNICATIONS.COLUMNS.NAME'),
      systemName: 'uId',
      uId: uuidv4(),
      isUniqueKey: false,
      fieldType: SystemFieldType.System,
      picklistValues: [],
      sourceUnit: null,
      settings: null
    } as SchemaField;

    var valueGetter = getValueGetter(FieldDataType.User);
    var cellRenderer = getCellRenderer(FieldDataType.User);
    columns.push({
      headerName: nameField.displayName,
      field: nameField.systemName,
      colId: 'uId',
      sortable: true,
      resizable: true,
      minWidth: 300,
      menuTabs: [],
      cellRenderer,
      cellRendererParams: {
        schemaField: nameField,
        nameFieldName: 'displayName',
        sortFieldName: 'displayName',
        picklistService: this.picklistService,
        clicked: data => {}
      },
      valueGetter
    });

    const email = {
      dataType: FieldDataType.Text,
      displayName: this.translateService.instant('COMMUNICATIONS.COLUMNS.EMAIL'),
      systemName: 'emailAddress',
      uId: uuidv4(),
      isUniqueKey: false,
      fieldType: SystemFieldType.System,
      picklistValues: [],
      sourceUnit: null
    } as SchemaField;

    valueGetter = getValueGetter(FieldDataType.Text);
    cellRenderer = getCellRenderer(FieldDataType.Text);
    columns.push({
      headerName: email.displayName,
      field: email.systemName,
      colId: 'emailAddress',
      sortable: true,
      resizable: true,
      minWidth: 800,
      //  maxWidth: 350,
      menuTabs: [],
      cellRenderer,
      cellRendererParams: {
        schemaField: email,
        picklistService: this.picklistService
      },
      valueGetter
    });

    return columns;
  }

  private loadRecipientTypes(): void {
    this.recipientTypes = [];

    if (this.includeDistro) {
      this.recipientTypes.push({
        uId: this.distRecipientTypeUId,
        name: this.translateService.instant('COMMUNICATIONS.RECIPIENT-TYPE-DIST-LIST'),
        icon: 'assets/images/purple_distro-group.svg'
      });
    }
    if (this.includeUsers === true && this.userContextService.getContext()?.hasPermission(Permissions.UserProfileRead)) {
      this.recipientTypes.push({
        uId: this.userRecipientTypeUId,
        name: this.translateService.instant('COMMUNICATIONS.RECIPIENT-TYPE-USERS'),
        icon: 'assets/images/purple_account-profile.svg'
      });
    }
    if (this.includeGroups === true) {
      this.recipientTypes.push({
        uId: this.groupRecipientTypeUId,
        name: this.translateService.instant('COMMUNICATIONS.RECIPIENT-TYPE-GROUPS'),
        icon: 'assets/images/people-group.svg'
      });
    }
    if (this.includeClosestAssets === true) {
      this.recipientTypes.push({
        uId: this.assetsRecipientTypeUId,
        name: this.translateService.instant('COMMUNICATIONS.RECIPIENT-TYPE-CLOSEST-ASSETS'),
        icon: 'assets/images/people-group.svg'
      });
    }

    if (this.includeDatasets) {
      this.getAssetDatasets()
        .pipe(take(1))
        .subscribe(data => {
          this.recipientTypes.push({
            uId: '0'
          });
          this.recipientTypes.push({
            uId: '1',
            name: `${this.translateService.instant('COMMUNICATIONS.DATASETS')}`
          });

          data.forEach(d => {
            this.recipientTypes.push({
              ...d,
              icon: this.getDatasetIcon(d)
            });
          });

          if (!!this.recipientTypes && this.recipientTypes.length) {
            if (!!!this.selectedRecipentTypeUId) {
              this.selectedRecipentTypeUId = this.recipientTypes[0].uId;
              this.previousSelectedRecipentTypeUId = this.selectedRecipentTypeUId;
            }
            this.selectedRecipentType = this.recipientTypes.find(t => t.uId === this.selectedRecipentTypeUId);
            this.headerLabel = this.selectedRecipentType?.name;
            this.headerIcon = this.selectedRecipentType?.icon;
            this.isDatasetSelected = this.getMassRecipientType() === MassRecipientType.Document;
            if (this.isDatasetSelected) {
              this.headerIcon = this.selectedRecipentType.icon;
            }
            this.columDefs = this.generateColumns();
            this.dataTable?.refreshGrid();
          }
        });
    }
  }

  private getAssetDatasets(): Observable<Dataset[]> {
    const queryParams: QueryParams = {
      skip: 0,
      take: 1000,
      where: `IsActive=true && type=${DatasetType.Assets} && (subtype=${DatasetSubtype.Person} || subtype=${DatasetSubtype.HorizonPerson} || subtype=${DatasetSubtype.Facility} || subtype=${DatasetSubtype.TravelItinerary})`,
      sortField: 'name',
      sortDirection: 'Ascending'
    };

    return this.datasetApiService.getDatasets(queryParams, true, true).pipe(
      catchError(() => of({ data: [] })),
      map(({ data }) => {
        return data;
      })
    );
  }

  private openDistributionListDetails(data: DistributionList): void {
    this.detailsContext = {
      distributionList: data
    };
  }

  private createDefaultView(dataset: Dataset): View {
    const view = {
      uId: uuidv4(),
      controls: []
    } as View;

    dataset?.schema?.fields
      ?.filter(f => f.dataType === FieldDataType.Picklist || f.dataType === FieldDataType.MultiPicklist)
      ?.forEach(f => {
        view.controls.push({
          uId: uuidv4(),
          dataSetFieldUId: f.uId,
          controlType: ViewControlType.DatasetField
        });
      });

    let keys = ['location', 'state', 'country', 'state_province_regio', 'city', 'department'];
    dataset?.schema?.fields
      ?.filter(f => f.dataType === FieldDataType.Text && keys.includes(f.systemName))
      ?.forEach(f => {
        view.controls.push({
          uId: uuidv4(),
          dataSetFieldUId: f.uId,
          controlType: ViewControlType.DatasetField
        });
      });

    return view;
  }

  onCloseRecipientDetails(): void {
    this.detailsContext = null;
  }

  async onRecipientTypeChanged(event: Event, recipientTypeUId: string): Promise<void> {
    const selectEl = event.target as HTMLSelectElement;
    // prevent UI from showing the select element changing in case of dialog confirmation
    selectEl.value = this.previousSelectedRecipentTypeUId;

    // filter out if somehow disabled options for divider and grouping get through
    if (!recipientTypeUId || recipientTypeUId === '0' || recipientTypeUId === '1') {
      return;
    }

    if (this.isDirty) {
      const dialogRef = this.showConfirmationDialog(
        'COMMUNICATIONS.CONFIRM-RECIPIENT-TYPE-CHANGE-TITLE',
        'COMMUNICATIONS.CONFIRM-RECIPIENT-TYPE-CHANGE-MESSAGE'
      );

      const shouldChange = await firstValueFrom(dialogRef.closed);

      if (!shouldChange) {
        return;
      }
    }

    // show new value for select element in UI
    selectEl.value = recipientTypeUId;
    this.selectedRecipentTypeUId = recipientTypeUId;

    this.gridHelper?.clearSearchFilter();
    this.dataTable?.hideSearch();
    this.selectionFilter = null;

    const columnState = {
      state: [
        {
          colId: '_selected',
          sort: 'desc'
        }
      ]
    } as ApplyColumnStateParams;

    this.dataTable?.gridApi.applyColumnState(columnState);

    this.previousSelectedRecipentTypeUId = this.selectedRecipentTypeUId;
    this.changeSelectedType();
  }

  private changeSelectedType(): void {
    this.selectedRecipientFilters = null;
    this.isLoading = true;
    this.loadData();
  }

  private loadData(): void {
    this.selectedRecipentType = this.recipientTypes.find(t => t.uId === this.selectedRecipentTypeUId);
    this.headerLabel = this.selectedRecipentType?.name;
    this.headerIcon = this.selectedRecipentType?.icon;
    const type = this.getMassRecipientType();
    this.isDatasetSelected = type === MassRecipientType.Document;
    this.skip = 0;
    this.dataTable?.gridApi?.deselectAll();
    this.isDirty = false;
    this.allowSaveAll = false;
    this.canChangeType = !!!this.intitalSelectedTypeUId;
    this.columDefs = this.generateColumns();
    this.selectedUIds = cloneDeep(this.getSelectedUIds(type, type === MassRecipientType.Document ? this.selectedRecipentTypeUId : null));
    this.dataTable?.refreshGrid();
    if (this.isDatasetSelected) {
      this.defaultTableView = this.createDefaultView(this.selectedRecipentType);
    }

    this.selectedDistributionListType = DistributionListType.None;
    this.hasDistTypes = false;
    const query = {
      skip: 0,
      take: 1,
      where: 'DistributionListType != DistributionListType.None'
    };
    this.communicationsApiService.getDistributionLists(query).subscribe(res => {
      this.hasDistTypes = res?.totalCount > 0;
    });
  }

  private getDatasetIcon(dataset: Dataset): string {
    if (dataset.subtype === DatasetSubtype.TravelItinerary) {
      return 'assets/images/avatars/traveler.svg';
    } else if (dataset.subtype === DatasetSubtype.Facility) {
      return 'assets/images/avatars/office.svg';
    } else {
      return 'assets/images/avatars/employee.svg';
    }
  }

  saveClick(close: boolean) {
    this.save(close);
  }

  changeSelectionFilter(value: string): void {
    this.selectionFilter = value;
    this.dataTable?.refreshGrid();
  }

  private save(close: boolean) {
    const type = this.getMassRecipientType();
    const selections = {
      uId: null,
      type: type,
      selectInfo: {
        selectAll: false,
        documentUIds: []
      }
    } as SelectedRecipientInfo;

    if (type !== MassRecipientType.Document) {
      selections.parentUId = null;
      selections.parentName = null;
      selections.parentIcon = null;

      this.selectedUIds?.forEach(s => {
        selections.selectInfo.documentUIds.push(s);
      });
      selections.documentCount = this.selectedUIds.length;

      this.recipientsSelected.emit(selections);
      this.dataTable?.refreshGrid();
    } else {
      selections.parentUId = this.selectedRecipentTypeUId;
      selections.parentName = this.selectedRecipentType?.name;
      selections.parentIcon = this.selectedRecipentType?.icon;

      this.selectedUIds?.forEach(s => {
        selections.selectInfo.documentUIds.push(s);
      });
      selections.documentCount = this.selectedUIds.length;

      selections.uId = this.selectedRecipientFilters?.find(r => r?.datasetUId === this.selectedRecipentTypeUId)?.uId ?? uuidv4();
      selections.filter = this.selectedRecipientFilters?.find(r => r?.datasetUId === this.selectedRecipentTypeUId)?.filter;

      this.recipientsSelected.emit(selections);
      this.dataTable?.refreshGrid();
    }

    this.isDirty = false;

    if (close) {
      this.close();
    }
  }

  close(): void {
    this.recipientsClosed.emit();
  }

  cancelClick(): void {
    if (!this.isDirty) {
      this.close();
      return;
    }

    const dialogRef = this.showConfirmationDialog('COMMUNICATIONS.CONFIRM-CANCEL', 'COMMUNICATIONS.CONFIRM-CANCEL-MESSAGE');

    dialogRef.closed.subscribe(shouldClose => {
      if (shouldClose) {
        this.close();
      }
    });
  }

  onSearchFilterChanged(filterGroup: FilterGroup): void {
    this.searchFilterGroup = filterGroup;
  }

  private getMassRecipientType(): MassRecipientType {
    if (this.selectedRecipentTypeUId === this.userRecipientTypeUId) {
      return MassRecipientType.User;
    } else if (this.selectedRecipentTypeUId === this.groupRecipientTypeUId) {
      return MassRecipientType.Group;
    } else if (this.selectedRecipentTypeUId === this.distRecipientTypeUId) {
      return MassRecipientType.DistributionList;
    } else {
      return MassRecipientType.Document;
    }
  }

  onRowSelected(event: any): void {
    if (this.isLoading === true) {
      return;
    }

    const type = this.getMassRecipientType();
    if (!!!this.selectedUIds) {
      this.selectedUIds = cloneDeep(this.getSelectedUIds(type, type === MassRecipientType.Document ? this.selectedRecipentTypeUId : null));
      if (!!!this.selectedUIds) {
        this.selectedUIds = [];
      }
    }
    const isSelected = event.node?.isSelected();
    var uid = type === MassRecipientType.Document ? event.node?.data?.uid : event.node?.data?.uId;
    if (isSelected === true) {
      if (!this.selectedUIds.includes(uid)) {
        this.selectedUIds.push(uid);
        this.isDirty = true;
      }
    } else if (isSelected === false) {
      const index = this.selectedUIds.indexOf(uid);
      if (index >= 0) {
        this.selectedUIds.splice(index, 1);
        this.isDirty = true;
      }
    }
  }

  onSelectData(data: any[]): void {
    if (this.isLoading === true) {
      return;
    }
    const type = this.getMassRecipientType();
    if (!!!this.selectedUIds) {
      this.selectedUIds = [];
    }

    const selectedUIds = cloneDeep(this.getSelectedUIds(type, type === MassRecipientType.Document ? this.selectedRecipentTypeUId : null));

    const newUIds = data.map(d => d.uId);
    if (newUIds.length !== selectedUIds.length || JSON.stringify(selectedUIds.sort()) !== JSON.stringify(newUIds.sort())) {
      this.isDirty = true;
      this.selectedUIds = newUIds;
    }
  }

  onGridDataLoaded(): void {
    if (this.readonlyTemplateRecipients === true) {
      this.dataTable?.gridApi?.sizeColumnsToFit();
      this.isLoading = false;
      return;
    }

    this.dataTable?.gridApi?.sizeColumnsToFit();

    this.isLoading = false;
  }

  onRowsChanged(): void {
    this.dataTable?.gridApi?.forEachNode(node => {
      if (this.selectedUIds?.includes(node.id) && !node.isSelected()) {
        node.setSelected(true, false, null);
      }
    });
  }

  getDatasetTableFilter(): TableFilter {
    return this.selectedRecipientFilters?.find(r => r?.datasetUId === this.selectedRecipentTypeUId)?.filter;
  }

  distributionListTypeChanged(event: any) {
    this.skip = 0;
    this.columDefs = this.generateColumns();
    this.dataTable?.refreshGrid();
  }

  documentFilterChanged(event: { filter: TableFilter; allowSaveAll: boolean }): void {
    if (!!!this.selectedRecipientFilters) {
      this.selectedRecipientFilters = [];
    }

    let recipientFilter = this.selectedRecipientFilters.find(r => r?.datasetUId === this.selectedRecipentTypeUId);
    if (!!!recipientFilter) {
      recipientFilter = {
        uId: uuidv4(),
        datasetUId: this.selectedRecipentTypeUId,
        datasetName: this.selectedRecipentType?.name,
        documentCount: 0,
        filter: null
      } as DatasetSelectedRecipientFilter;
      this.selectedRecipientFilters.push(recipientFilter);
    }
    recipientFilter.filter = event.filter;
    this.allowSaveAll = event.allowSaveAll;
    this.dataTable?.refreshGrid();
  }

  canSave(): boolean {
    if (this.isDirty !== true) {
      return false;
    }
    return true;
  }

  private getFilterGroupFromTableFilter(): FilterGroup {
    const recipientFilter = this.selectedRecipientFilters?.find(r => r?.datasetUId === this.selectedRecipentTypeUId);
    return this.recipientSelectionService.getFilterGroupFromTableFilter(recipientFilter?.filter);
  }

  private getFilterGroupFromSelection(uids: string[]): FilterGroup {
    const filterGroup = {
      groupType: FilterGroupType.And,
      filters: [],
      filterGroups: []
    } as FilterGroup;

    filterGroup.filters.push({
      field: 'uid',
      operator: RuleOperator.In,
      value: uids.join(',')
    });

    return filterGroup;
  }

  private showConfirmationDialog(title: string, message: string): DialogRef {
    return this.dialog.open(ConfirmationDialogComponent, {
      autoFocus: true,
      width: '100%',
      maxWidth: '600px',
      data: {
        title,
        message,
        isDangerous: true,
        icon: 'icon-close-X'
      }
    });
  }
}

export interface SelectedRecipientInfo {
  uId?: string;
  type: MassRecipientType;
  displayName?: string;
  parentUId: string;
  parentName: string;
  parentIcon: string;
  selectInfo: DocumentSelectionInfo;
  documentCount: number;
  filter?: TableFilter;
}
